import { render, staticRenderFns } from "./TagsSelector.vue?vue&type=template&id=58ed328a&"
import script from "./TagsSelector.vue?vue&type=script&lang=js&"
export * from "./TagsSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagsSelector.vue?vue&type=style&index=0&id=58ed328a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports